import _ from 'lodash';
import DecimalAmount from '../../../../support/DecimalAmount';

class ComercioExteriorMercanciasCalculator {
  data = {}

  constructor(data) {
    this.data = data;
  }

  static make(data) {
    return new ComercioExteriorMercanciasCalculator(data);
  }

  get() {
    const TotalUSD = this.getTotalUsd();

    return {
      TotalUSD
    }
  }

  getTotalUsd() {
    return _.sumBy(this.data, (item) => {
      return parseFloat(item.ValorDolares);
    });
  }

  countDecimals(value) {
    if (value.indexOf('.') !== -1) {
      return value.split('.')[1].length;
    }

    return 0;
  }

  getLimiteInferior() {
    if (!_.isEmpty(this.data.CantidadAduana) && ! _.isEmpty(this.data.ValorUnitarioAduana)) {
      const decimalsCantidadAduana = this.countDecimals(this.data.CantidadAduana);
      const decimalsValorUnitarioAduana = this.countDecimals(this.data.ValorUnitarioAduana);

      const CantidadAduana = (parseFloat(this.data.CantidadAduana) - Math.pow(10, -decimalsCantidadAduana) / 2);
      const ValorUnitarioAduana = (parseFloat(this.data.ValorUnitarioAduana) - Math.pow(10, -decimalsValorUnitarioAduana) / 2);

      return DecimalAmount.make(CantidadAduana * ValorUnitarioAduana).floor().get();
    }

    return 0;
  }

  getLimiteSuperior() {
    if (!_.isEmpty(this.data.CantidadAduana) && ! _.isEmpty(this.data.ValorUnitarioAduana)) {
      const decimalsCantidadAduana = this.countDecimals(this.data.CantidadAduana);
      const decimalsValorUnitarioAduana = this.countDecimals(this.data.ValorUnitarioAduana);

      const CantidadAduana = (parseFloat(this.data.CantidadAduana) + Math.pow(10, -decimalsCantidadAduana) / 2) - Math.pow(10, -12);
      const ValorUnitarioAduana = (parseFloat(this.data.ValorUnitarioAduana) + Math.pow(10, -decimalsValorUnitarioAduana) / 2) - Math.pow(10, -12);

      return DecimalAmount.make(CantidadAduana * ValorUnitarioAduana).round().get();
    }

    return 0;
  }

}

export default ComercioExteriorMercanciasCalculator;